import { useRef, useState } from 'react';
import { callApi } from './api';
import { getStoredKanriEditToken, saveKanriEditToken } from './kanriEditToken';

/** トップページ隅の非公開機能「管理者編集」。今のところは準備中のダミー画面。 */
export default function KanriEditScreen({ onBack }) {
  const [token, setToken] = useState(() => getStoredKanriEditToken());
  const [password, setPassword] = useState('');
  const [unlocking, setUnlocking] = useState(false);
  const [unlockError, setUnlockError] = useState('');
  const unlockingRef = useRef(false);

  async function handleUnlock(e) {
    e.preventDefault();
    if (!password || unlockingRef.current) return;
    unlockingRef.current = true;
    setUnlocking(true);
    setUnlockError('');
    try {
      const data = await callApi('kanri_edit_login', { password });
      saveKanriEditToken(data.token);
      setToken(data.token);
      setPassword('');
    } catch (err) {
      setUnlockError(err.message);
    } finally {
      unlockingRef.current = false;
      setUnlocking(false);
    }
  }

  return (
    <div className="workspace">
      <div className="workspace-head reveal r1">
        <button className="back-link" type="button" onClick={onBack}>← ホームへ戻る</button>
        <h1 className="workspace-title">管理者編集</h1>
      </div>

      {!token && (
        <form className="editor-card reveal r2" onSubmit={handleUnlock}>
          <p className="admin-lock-note">この機能を開くには、パスワードが必要です。</p>
          <div className="admin-lock-row">
            <input
              type="password" className="admin-password-input" placeholder="パスワード" autoComplete="off"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setUnlockError(''); }}
              disabled={unlocking}
            />
            <button className="enter admin-unlock-btn" type="submit" disabled={!password || unlocking}>
              {unlocking ? '確認中…' : '開く'}
            </button>
          </div>
          {unlockError && <p className="pin-error" role="alert">{unlockError}</p>}
        </form>
      )}

      {token && (
        <div className="editor-card reveal r2">
          <p className="workspace-loading">準備中です。もうしばらくお待ちください。</p>
        </div>
      )}
    </div>
  );
}
